/**
 * @generated SignedSource<<aecc8ed35f75d3e38e339944326c7eca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UnsubscribeMutation$variables = {
  email?: string | null;
};
export type UnsubscribeMutation$data = {
  readonly unsubscribe: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  } | null;
};
export type UnsubscribeMutation = {
  response: UnsubscribeMutation$data;
  variables: UnsubscribeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "concreteType": "ValidationResponse",
    "kind": "LinkedField",
    "name": "unsubscribe",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnsubscribeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnsubscribeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5444349c37cb1543d33d4d2b8e379c05",
    "id": null,
    "metadata": {},
    "name": "UnsubscribeMutation",
    "operationKind": "mutation",
    "text": "mutation UnsubscribeMutation(\n  $email: String\n) {\n  unsubscribe(email: $email) {\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "23ba1756b4a977d9b947301220566324";

export default node;
